import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { NewBroadcastMessage } from "../../../StaffCommunication/util/Broadcast/NewBroadcastMessage";

export const BroadcastMessage = ({ isMobile }: { isMobile?: boolean }) => {
	const navigate = useNavigate();
	const { chosenDepartment } = useHospitalData();
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				height: "calc(100% - 10px)",
				justifyContent: "space-between",
				bgcolor: "white",
				p: 2,
				borderRadius: 2,
				overflow: "auto",
				boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
			}}
		>
			<NewBroadcastMessage
				onClose={() => {
					const path = `/${chosenDepartment.department_id}/messages`;
					navigate(path);
				}}
				isMobile={isMobile}
			/>
		</Box>
	);
};
